/* unplugin-vue-components disabled */import { render } from "./ErrorDialog.vue?vue&type=template&id=7de6988e&scoped=true&ts=true"
import script from "./ErrorDialog.vue?vue&type=script&lang=ts"
export * from "./ErrorDialog.vue?vue&type=script&lang=ts"

import "./ErrorDialog.vue?vue&type=style&index=0&id=7de6988e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7de6988e"]])

export default __exports__